var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElbil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ElBil"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.55,14.77l3.38-3.38L25.52,10l-3.38,3.38-3.5-3.5L22,6.48,20.61,5.07,17.23,8.45,14.66,5.89,13.25,7.3l.52.52L8.6,13a4.26,4.26,0,0,0,0,6l1.48,1.48-5,5,1.41,1.41,5-5L13,23.4a4.25,4.25,0,0,0,6,0l5.16-5.16.52.52,1.41-1.41ZM17.6,22a2.25,2.25,0,0,1-3.2,0L10,17.6a2.25,2.25,0,0,1,0-3.2l5.16-5.17,7.59,7.59Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElbil);
export default __webpack_public_path__ + "static/media/Elbil.f805f058787e4cf0189ed6978cb2fc4f.svg";
export { ForwardRef as ReactComponent };